import request from '@/utils/http';

// 运单列表查询
export const queryWaybillOrderListLSP = (data) => {
    return request({
        url: '/api-antms/query/lsp/transport/queryByPage',
        method: 'post',
        data
    });
};

// 运单管理-列表分页统计数量
export const queryCountLSP = data => {
    return request({
        url: '/api-antms/query/lsp/transport/queryCount',
        method: 'post',
        data
    });
};

// 运单列表查询
export const queryWaybillOrderList = (data) => {
    return request({
        url: '/api-antms/query/transport/queryByPage',
        method: 'post',
        data
    });
};

// 运单管理-列表分页统计数量
export const queryCount = data => {
    return request({
        url: '/api-antms/query/transport/queryCount',
        method: 'post',
        data
    });
};

// 运输单明细
export const queryWaybillDetail = (params) => {
    return request({
        url: '/api-antms/query/transport/queryDetails',
        method: 'get',
        params
    });
};

// 运输单明细 - 列表
export const queryWaybillDetailList = (data) => {
    return request({
        url: `/api-antms/query/transport/queryDetailList?taskNo=${data}`,
        method: 'get'
    });
};

// 拉取OTP装货数据
export const getOtpLoadData = (data) => {
    return request({
        url: '/api-antms/transport/transport/getOtpLoadData',
        method: 'post',
        data
    });
};

// 绑定零担运单号
export const bindLclNo = (data) => {
    return request({
        url: '/api-antms/transport/transportLcl/bindLclNo',
        method: 'post',
        data
    });
};

// 获取运单状态
export const queryStatusRoute = (data) => {
    return request({
        url: `/api-antms/query/transport/statusRoute?id=${data}`,
        method: 'get',
        data
    });
};

export const queryLogDetail = (data) => {
    return request({
        url: `/api-antms/transport/print/dispatch/log/detail`,
        method: 'get',
        params: data
    });
};
